'use strict';
import { Component, Inject, Input} from 'ng-metadata/core';
import {PermalinkService} from './permalink.service';

import {SelectTextUtil} from '../../../infra/selectTextUtil';
import {PnxUtil} from '../../../nddUtils/pnxUtil.service';
import {SearchFieldsService} from '../../search.fields.service';
import { PrimolyticsService } from '../../../analytics/primolytics.service';
import {MediaQueries} from "../../../infra/mediaQueries.service";


@Component({
    "selector": "prm-permalink",
    templateUrl: 'components/search/actions/permalinkAction/permalink.html'
})


export class PrmPermalink{
    @Input() public selectedIds: Object;
    @Input() private item: Object;
    @Input() private isShareAction: boolean; 
    private currentAction: string;
        
   
    constructor(private permalinkService: PermalinkService,
                private selectTextUtil: SelectTextUtil,
                private pnxUtil: PnxUtil,
                private mediaQueries: MediaQueries,
                private primolyticsService: PrimolyticsService,
                @Inject('$state') private $state: ng.ui.IStateService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                private searchFieldsService: SearchFieldsService){
                this.currentAction = this.isShareAction ? 'share' : 'permalink';
    }

    ngOnInit() {
        if (this.$state.current.name === "servicesPage"){
            this.permalink = window.location.href;
            this.shortPermalink = window.location.href;
        } else {
            this.permalinkService.getPermalink(this.item, this.selectedIds)
                .then((response) => this.successAction(response));
        }
      }

    get permalink() {
        return this.permalinkService.permalink;
    }

    set permalink(permalink) {
        this.permalinkService.permalink = permalink;
    }

    get shortPermalink() {
        return this.permalinkService.shortPermalink;
    }

    set shortPermalink(shortPermalink) {
        this.permalinkService.shortPermalink = shortPermalink;
    }

    successAction(response){
        const permalink = response.data.permalink;
        this.permalink = permalink.includes('lang=') ? permalink : permalink + '&lang=' + this.$translate.use();
        if(response.data.shortPermalink){
            this.shortPermalink = response.data.shortPermalink;
        }
        else{
            this.shortPermalink = this.permalink;
        }
    }

    //selects (highlights) permalink text
    selectText(identifier) {
        this.selectTextUtil.selectText(identifier + this.getRecordId());
    }

    getRecordId(){
        return this.pnxUtil.getValue(this.item, 'control', 'recordid');
    }

    displayCopyButton(){
        return !(/iPod/.test(navigator.userAgent) && !window.MSStream);
    }

    private runBeacon(operation) {
        this.primolyticsService.doBeaconReport({
            'p': 'sendTo',
            'op': operation
        }, this.primolyticsService.getTimestamp());
    }

    public runOperationBeacon(operation) {
        this.runBeacon(operation);
    }
}








// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/permalinkAction/permalink.directive.ts